<template>
    <div class="flex flex-col gap-y-6">
        <p class="text-lg leading-7 font-medium text-black">Days of the week workflow should trigger</p>
        <GgmsMultiSelect
            v-model="workflowStore.modelValue.days"
            :options="daysOptions"
            placeholder="Choose day or days"
            classes="w-full"
        ></GgmsMultiSelect>
        <GgmsInput
            v-model="workflowStore.modelValue.time"
            label="Select time"
            type="time"
            :iconStart="ClockIcon"
        ></GgmsInput>
    </div>
</template>
<script setup lang="ts">
import { watch } from "vue"
import GgmsMultiSelect from "@/components/GgmsMultiSelect.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import { ClockIcon } from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"
import { dateTimeConverter } from "@/shared/utils/helpers"

const workflowStore = useWorkflowStore()

const daysOptions = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]

watch(
    () => workflowStore.modelValue.time,
    () => {
        //convert time into ISO date
        if (workflowStore.modelValue.time) {
            workflowStore.modelValue.dateTime = dateTimeConverter(workflowStore.modelValue.time)
        }
    }
)

watch(
    () => [workflowStore.modelValue.days, workflowStore.modelValue.time],
    () => {
        workflowStore.areButtonDisabled = !workflowStore.modelValue.days.length || !workflowStore.modelValue.time
    }
)
</script>
